import { ref } from "vue";

export const showProductAssociated = ref<boolean>(false);